import { render, staticRenderFns } from "./CustomizeCard.vue?vue&type=template&id=b3b16084&scoped=true&"
import script from "./CustomizeCard.vue?vue&type=script&lang=js&"
export * from "./CustomizeCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeCard.vue?vue&type=style&index=0&id=b3b16084&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b16084",
  null
  
)

export default component.exports